import { getAudioContext } from '../audio/Context';
import { trimBuffer } from '../audio/AudioUtils';
import { reportBFError } from '../utils/Tracker';

export default class {
  isLoaded: boolean;

  private request: XMLHttpRequest;
  private shouldPlay: boolean;
  private source: AudioBufferSourceNode;
  private startedAt: number;

  constructor(url: string) {
    this.request = new XMLHttpRequest();
    this.request.open('GET', url, true);
    this.request.responseType = 'arraybuffer';
    this.isLoaded = false;

    // Decode asynchronously
    this.request.onload = () => {
      getAudioContext().decodeAudioData(
        this.request.response,
        this.onBufferLoaded,
        error => reportBFError(error)
      );
    };
    this.request.send();
    this.shouldPlay = true;
  }
  onBufferLoaded = (buffer: AudioBuffer) => {
    if (!this.shouldPlay) {
      return;
    }
    this.isLoaded = true;
    this.source = getAudioContext().createBufferSource(); // creates a sound source
    this.source.buffer = trimBuffer(buffer); // tell the source which sound to play
    this.source.connect(getAudioContext().destination); // connect the source to the context's destination (the speakers)
    this.source.start(0);
    this.startedAt = Date.now();
  };
  getPosition() {
    // 0-1
    if (!this.isLoaded) {
      return 0;
    }
    return (
      (Date.now() - this.startedAt) / (this.source.buffer!.duration * 1000)
    );
  }
  dispose() {
    if (this.source) {
      this.source.disconnect();
    }
    this.request.abort();
    this.shouldPlay = false;
  }
}



// WEBPACK FOOTER //
// ./src/audio-editing/TrackPlayer.ts